import React from "react";
import ImpactCard from "./ImpactCard";
import image1 from "../../assets/image1.jpg";
import image2 from "../../assets/image2.jpg";
import image3 from "../../assets/image3.jpg";
import image5 from "../../assets/image5.jpg";
import image6 from "../../assets/image6.jpg";
import image7 from "../../assets/image7.jpg";
import classes from './Impact.module.css';
import SectionHeading from "../../ReusableComponents/SectionHeading/SectionHeading";
import Reveal from "../../ReusableComponents/Reveal/Reveal";

const Impact = () => {
  const impactData = [
    {
      title: "A People’s Person",
      content:
        "Jose Charles Martin initiated a school adoption drive to improve neglected government schools, upgrading infrastructure, health and hygiene, and learning conditions. He also leads relief efforts during natural disasters such as floods, mobilizing trucks, supplies, and medical aid, cleaning affected areas, visiting locations facing issues like contaminated water or garbage accumulation, and raising awareness about social and environmental challenges.",
      image: image1,
    },
    {
      title: "Empowering Employment",
      content:
        "Employment creation is one of the most direct ways to empower a nation. Through its wide-ranging ventures, The Charles Group has created both direct and indirect employment for tens of thousands of people. From engineers and technicians to artisans and educators, the group provides dignified employment with fair wages and professional development. Each job created by Jose is more than just a paycheck- it is a stepping stone to a better life. For him, treating employees as human beings first is one of his core values.",
      image: image2,
    },
    {
      title: "Driving India’s Development",
      content:
        "Jose believes in improving science and technology with inclusivity and a people-first approach. As part of his commitment to sustainability and green technologies, he is investing in MIW– Miracle in Water, a cutting-edge water treatment and odor management solution that is revolutionizing how water and waste are treated across industries. He is also focused on making space education accessible, engaging, and equitable for every child, especially in underserved communities. For him, space is not just a subject; it is a doorway to possibilities, innovation, and a better future. He ensures that knowledge of rockets, satellites, and galaxies reaches classrooms that previously had no access to telescopes or basic science kits. This was achieved through one of his initiatives, The Launch, in February 2023, involving thousands of students who developed 150 pico-satellites sent up on a hybrid sounding rocket. Jose is entering the electric mobility sector with a revolutionary e-bike project designed to redefine range, efficiency, and sustainability. The first version will deliver an impressive 400–500 km range on a single charge without increasing battery size-a breakthrough in long-range, accessible electric transportation.",
      image: image3,
    },
    //     {
    //       title: "Innovation & Sustainability",
    //       content:
    //         "Jose Charles Martin envisions a transformative Puducherry because it's a region destined to become the next Singapore of the world. With its beautiful coastline, strong educational base, and enterprising people, Puducherry holds every element needed to stand tall as a global model of progress and sustainability. He believes that Puducherry deserves to be great not just as a tourist destination, but as a world-class hub of innovation, opportunity, and inclusive growth. His dream is to build a Puducherry that shines with modern infrastructure, clean water, green spaces, advanced technology, and empowered citizens. Jose’s mission is deeply rooted in people-first development. He aims to uplift every citizen through quality education, skill development, and dignified employment, ensuring that no one is left behind in the journey of progress. By promoting sustainability, clean energy, and responsible urban growth, he aspires to make Puducherry a model coastal city that balances modernization with harmony and care for the environment. Through inclusive education, youth empowerment, green initiatives, and innovative entrepreneurship, he seeks to create a society where every individual can live with dignity, security, and pride. For Jose Charles Martin, Puducherry is not just a place- it is a promise. A promise to become the next Singapore of the world- a symbol of what responsible businessmen, collective effort, and human values can truly achieve. Thereby, he ensures
    // inclusive growth in Puducherry.",
    //       image: image4,
    //     },
    {
      title: "International Participation",
      content:
        "Jose actively engages in international cultural exchange, sports diplomacy, and youth empowerment. His vision of enhancing youth skills, promoting inclusive education, and standing for social causes has been recognized globally. He was awarded the SDG Impact Award at the United Nations, Bangkok (2025), for outstanding contributions to inclusive, equitable, and sustainable development.",
      image: image5,
    },
    {
      title: "Champion of Sports & Culture",
      content:
        "Jose is an avid sports enthusiast and works to make sports accessible to all. He actively supports the Modern Pythian Games, celebrating arts, culture, and traditional sports. He serves as Youth Global Cultural Ambassador for the games, representing 92 countries and promoting cross-cultural sports diplomacy, positioning himself as an icon of youth engagement in sports.",
      image: image6,
    },
    {
      title: "Legacy of Compassion",
      content:
        "From business to social service, from local action to global recognition, Jose Charles Martin builds people, communities, and hope. His journey demonstrates that true leadership is measured by the lives one uplifts.",
      image: image7,
    },
  ];

  return (
    <section id="impact" className={classes.impactSection}>
      <div className={classes.inner}>
        <SectionHeading
          eyebrow="In practice"
          title="Impact"
          lead="Schools adopted, jobs created, relief mobilised — the work behind the profile."
        />

        <Reveal
          className={classes.gridContainer}
          selector="[data-card]"
          stagger={0.08}
          y={40}
        >
          {impactData.map((item, index) => (
            <ImpactCard
              key={item.title}
              index={index}
              title={item.title}
              content={item.content}
              image={item.image}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Impact;
